import React, { useRef, useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

// کامپوننت‌های لندینگ
import NonHealthFeatures from "@/components/landing/NonHealthFeatures/index";
import PersonaGrid from "../components/landing/PersonaGrid";
import FAQSection from "../components/landing/FAQSection";
import FinalCTA from "../components/landing/FinalCTA";
import Testimonials from "@/components/Testimonials";
import { useWatchTestimonials } from "../testimonialsData/watchTestimonials";
import HeroSection from "@/components/landing/WatchHeroSection";
import LifestyleUseCasesWatch from "@/components/landing/deta-LifestyleUseCases/LifestyleUseCasesWatch";
import WatchHardwareFeatures from "@/components/landing/deta-HardwareFeatures/WatchHardwareFeatures";
import KidWatchComparison from "@/components/landing/KidWatchComparison";
import { motion } from "framer-motion";
import { watchFaqs } from "../components/landing/deta-FAQ/watchFaqs";
import WatchAssistantSection from "@/components/landing/WatchAssistantSection";
import { Helmet } from "react-helmet-async";


const WatchesPage: React.FC = () => {

  const productComparisonRef = useRef(null);
    const [triggerAnimation, setTriggerAnimation] = useState(0);
    const watchTestimonials = useWatchTestimonials();

    // Structured Data
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "ساعت هوشمند کودک دلبند",
      "description": "ساعت هوشمند کودک با قابلیت‌های GPS و تماس دوطرفه",
      "brand": {
        "@type": "Brand",
        "name": "دلبند"
      },
      "category": "ساعت هوشمند کودک"
    };
  
    const scrollToProductComparison = () => {
      if (productComparisonRef.current) {
        // تاخیر کوتاه برای انیمیشن بهتر
        setTimeout(() => {
          ((productComparisonRef.current as unknown) as HTMLElement).scrollIntoView({
            behavior: 'instant', // بدون نمایش اسکرول
            block: 'start',
          });
          
          // trigger کردن انیمیشن با تغییر key
          setTimeout(() => {
            setTriggerAnimation(prev => prev + 1);
          });
        }, 300);
      }
    };

    
    return (
        <>
            <Helmet>
                <title>ساعت هوشمند کودک دلبند - همراهی ایمن و هوشمند</title>
                <meta name="description" content="ساعت هوشمند کودک دلبند با قابلیت‌های GPS، تماس دوطرفه و دکمه SOS، امنیت و ارتباط آسان را برای فرزندان شما فراهم می‌کند. آرامش خاطر والدین با دلبند." />
                <meta name="keywords" content="ساعت هوشمند کودک, ردیاب کودک, تماس اضطراری, GPS کودک, امنیت کودک" />
                <link rel="canonical" href="https://delband.com/smart-watches" />
                <meta property="og:title" content="ساعت هوشمند کودک دلبند - ایمنی و ارتباط آسان" />
                <meta property="og:url" content="https://delband.com/smart-watches" />
                <script type="application/ld+json">
                    {JSON.stringify(structuredData)}
                </script>
            </Helmet>
            <div className="bg-[#F8F9FC] relative w-full overflow-x-clip">
            <Header />
            <main className="container mx-auto px-2 pb-8 pt-26 sm:pt-24 md:pt-21 max-w-7xl overflow-x-clip">
                <div className="absolute top-0 right-0 w-[300px] h-[300px] bg-[#f4bb90] rounded-full blur-[120px] opacity-40 z-0 pointer-events-none"></div>
                <div className="absolute bottom-0 left-[-14%] w-[300px] h-[300px] bg-gray-600 rounded-full blur-[120px] opacity-15 sm:opacity-25 z-[999999] pointer-events-none"></div>
                {/* بخش قهرمان */}
                <HeroSection onCompareClick={scrollToProductComparison} />

               

                {/* بخش سنسورهای سلامت */}
                <NonHealthFeatures />
                {/* <DataFlowInsight /> */}
                {/* بخش ویژگی‌های سخت‌افزاری */}
                <WatchHardwareFeatures />
                    <WatchAssistantSection/>
                {/* بخش فراتر از سلامت */}
                {/* <BeyondHealthServices /> */}

                {/* بخش کاربردهای روزمره */}
                <LifestyleUseCasesWatch />

                {/* بخش مناسب برای چه کسانی */}
                <PersonaGrid />

                {/* بخش مقایسه محصولات */}
                <motion.div
                    key={triggerAnimation}
                    ref={productComparisonRef}
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                    viewport={{ once: false, margin: "-100px" }}
                >
                    <KidWatchComparison />
                </motion.div>

                {/* بخش نظرات کاربران */}
                {/* <TestimonialsSection /> */}
                <Testimonials data={watchTestimonials} translationNamespace="watchTestimonials" />
                {/* بخش سوالات متداول */}
                <FAQSection faqs={watchFaqs} translationNamespace="watchFAQs" />
            </main>
            <div className="container mx-auto pb-10">
                <FinalCTA />
            </div>
            {/* بخش دعوت به عمل نهایی */}

            <Footer />
        </div>
        </>
    );
};

export default WatchesPage;
